import axios from "axios";

import { api } from "../../apis";
import { helperFunction } from "../../constant/helper";
import { types } from "../type";

// set loading
const setHolidayLoading = (data) => (dispatch) => {
  dispatch({
    type: types.HolidayTypes.HOLIDAY_SET_LOADING,
    payload: data
  });
};

// clear result
const clearHolidayResult = () => (dispatch) => {
  dispatch({
    type: types.HolidayTypes.HOLIDAY_CLEAR_RESULT
  });
};

// unMount Holidays
const unmountAllHolidaysData = () => (dispatch) => {
  dispatch({
    type: types.HolidayTypes.HOLIDAY_UNMOUNT
  });
};

// clear error
const clearHolidayErrors = () => (dispatch) => {
  dispatch({
    type: types.HolidayTypes.HOLIDAY_CLEAR_ERRORS
  });
};

// add missing attendance
const addHolidayList = (holidayData, loginType) => async (
  dispatch
) => {
  try {
    const { baseUrlNode } = await helperFunction.checkLoginType(
      loginType
    );
    const addHolidayListSuccess = await axios.post(
      `${baseUrlNode}${api.Holiday_Api.ADD_HOLIDAY_LIST}`,
      holidayData
    );
    dispatch({
      type: types.HolidayTypes.ADD_HOLIDAY_LIST,
      payload: addHolidayListSuccess.data
    });
  } catch (addHolidayListError) {
    const errorData = {
      data: addHolidayListError.response.data,
      status: addHolidayListError.response.status
    };
    dispatch({
      type: types.HolidayTypes.HOLIDAY_GET_ERRORS,
      payload: errorData
    });
  }
};

export {
  setHolidayLoading,
  clearHolidayResult,
  unmountAllHolidaysData,
  clearHolidayErrors,
  addHolidayList
};
